var _rect, _path, _mask, _path2, _path3, _mask2, _path4, _path5, _rect2, _mask3, _path6, _path7, _mask4, _path8, _path9, _rect3, _mask5, _path10, _path11, _mask6, _path12, _path13, _rect4, _mask7, _path14, _path15, _mask8, _path16, _path17, _rect5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158,
    rx: 79,
    fill: "#EDF3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7266 25.1785C78.8927 25.0701 79.1073 25.0701 79.2734 25.1785L126.593 56.0814C127.01 56.3532 126.817 57 126.32 57H31.6801C31.1829 57 30.9904 56.3532 31.4067 56.0814L78.7266 25.1785Z",
    fill: "#4B81F4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 57.5C30 57.2239 30.2239 57 30.5 57H127.5C127.776 57 128 57.2239 128 57.5V62.5C128 62.7761 127.776 63 127.5 63H30.5C30.2239 63 30 62.7761 30 62.5V57.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57.5C30 57.2239 30.2239 57 30.5 57H127.5C127.776 57 128 57.2239 128 57.5V62.5C128 62.7761 127.776 63 127.5 63H30.5C30.2239 63 30 62.7761 30 62.5V57.5Z",
    fill: "#4B81F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57.5C30 56.9477 30.4477 56.5 31 56.5H127C127.552 56.5 128 56.9477 128 57.5C128 57.5 127.776 57.5 127.5 57.5H30.5C30.2239 57.5 30 57.5 30 57.5ZM128 62.5C128 63.0523 127.552 63.5 127 63.5H31C30.4477 63.5 30 63.0523 30 62.5C30 62.5 30.2239 62.5 30.5 62.5H127.5C127.776 62.5 128 62.5 128 62.5ZM30 63V57V63ZM128 57V63V57Z",
    fill: "#E4E4E4",
    mask: "url(#path-3-inside-1_4168_48649)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 63.5C34 63.2239 34.2239 63 34.5 63H51.5C51.7761 63 52 63.2239 52 63.5V68.5C52 68.7761 51.7761 69 51.5 69H34.5C34.2239 69 34 68.7761 34 68.5V63.5Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 63.5C34 63.2239 34.2239 63 34.5 63H51.5C51.7761 63 52 63.2239 52 63.5V68.5C52 68.7761 51.7761 69 51.5 69H34.5C34.2239 69 34 68.7761 34 68.5V63.5Z",
    fill: "#4B81F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 63H52H34ZM52 68.5C52 69.0523 51.5523 69.5 51 69.5H35C34.4477 69.5 34 69.0523 34 68.5C34 68.5 34.2239 68.5 34.5 68.5H51.5C51.7761 68.5 52 68.5 52 68.5ZM34 69V63V69ZM52 63V69V63Z",
    fill: "#E4E4E4",
    mask: "url(#path-5-inside-2_4168_48649)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 69,
    width: 12,
    height: 42,
    fill: "#4B81F4"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-3_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 111.5C34 111.224 34.2239 111 34.5 111H51.5C51.7761 111 52 111.224 52 111.5V116.5C52 116.776 51.7761 117 51.5 117H34.5C34.2239 117 34 116.776 34 116.5V111.5Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111.5C34 111.224 34.2239 111 34.5 111H51.5C51.7761 111 52 111.224 52 111.5V116.5C52 116.776 51.7761 117 51.5 117H34.5C34.2239 117 34 116.776 34 116.5V111.5Z",
    fill: "#4B81F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111.5C34 110.948 34.4477 110.5 35 110.5H51C51.5523 110.5 52 110.948 52 111.5C52 111.5 51.7761 111.5 51.5 111.5H34.5C34.2239 111.5 34 111.5 34 111.5ZM52 117H34H52ZM34 117V111V117ZM52 111V117V111Z",
    fill: "#E4E4E4",
    mask: "url(#path-8-inside-3_4168_48649)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-4_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 63.5C70 63.2239 70.2239 63 70.5 63H87.5C87.7761 63 88 63.2239 88 63.5V68.5C88 68.7761 87.7761 69 87.5 69H70.5C70.2239 69 70 68.7761 70 68.5V63.5Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63.5C70 63.2239 70.2239 63 70.5 63H87.5C87.7761 63 88 63.2239 88 63.5V68.5C88 68.7761 87.7761 69 87.5 69H70.5C70.2239 69 70 68.7761 70 68.5V63.5Z",
    fill: "#4B81F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63H88H70ZM88 68.5C88 69.0523 87.5523 69.5 87 69.5H71C70.4477 69.5 70 69.0523 70 68.5C70 68.5 70.2239 68.5 70.5 68.5H87.5C87.7761 68.5 88 68.5 88 68.5ZM70 69V63V69ZM88 63V69V63Z",
    fill: "#E4E4E4",
    mask: "url(#path-10-inside-4_4168_48649)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 69,
    width: 12,
    height: 42,
    fill: "#4B81F4"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-5_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 111.5C70 111.224 70.2239 111 70.5 111H87.5C87.7761 111 88 111.224 88 111.5V116.5C88 116.776 87.7761 117 87.5 117H70.5C70.2239 117 70 116.776 70 116.5V111.5Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70 111.5C70 111.224 70.2239 111 70.5 111H87.5C87.7761 111 88 111.224 88 111.5V116.5C88 116.776 87.7761 117 87.5 117H70.5C70.2239 117 70 116.776 70 116.5V111.5Z",
    fill: "#4B81F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70 111.5C70 110.948 70.4477 110.5 71 110.5H87C87.5523 110.5 88 110.948 88 111.5C88 111.5 87.7761 111.5 87.5 111.5H70.5C70.2239 111.5 70 111.5 70 111.5ZM88 117H70H88ZM70 117V111V117ZM88 111V117V111Z",
    fill: "#E4E4E4",
    mask: "url(#path-13-inside-5_4168_48649)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-6_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 63.5C106 63.2239 106.224 63 106.5 63H123.5C123.776 63 124 63.2239 124 63.5V68.5C124 68.7761 123.776 69 123.5 69H106.5C106.224 69 106 68.7761 106 68.5V63.5Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106 63.5C106 63.2239 106.224 63 106.5 63H123.5C123.776 63 124 63.2239 124 63.5V68.5C124 68.7761 123.776 69 123.5 69H106.5C106.224 69 106 68.7761 106 68.5V63.5Z",
    fill: "#4B81F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106 63H124H106ZM124 68.5C124 69.0523 123.552 69.5 123 69.5H107C106.448 69.5 106 69.0523 106 68.5C106 68.5 106.224 68.5 106.5 68.5H123.5C123.776 68.5 124 68.5 124 68.5ZM106 69V63V69ZM124 63V69V63Z",
    fill: "#E4E4E4",
    mask: "url(#path-15-inside-6_4168_48649)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 69,
    width: 12,
    height: 42,
    fill: "#4B81F4"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-7_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 111.5C106 111.224 106.224 111 106.5 111H123.5C123.776 111 124 111.224 124 111.5V116.5C124 116.776 123.776 117 123.5 117H106.5C106.224 117 106 116.776 106 116.5V111.5Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106 111.5C106 111.224 106.224 111 106.5 111H123.5C123.776 111 124 111.224 124 111.5V116.5C124 116.776 123.776 117 123.5 117H106.5C106.224 117 106 116.776 106 116.5V111.5Z",
    fill: "#4B81F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106 111.5C106 110.948 106.448 110.5 107 110.5H123C123.552 110.5 124 110.948 124 111.5C124 111.5 123.776 111.5 123.5 111.5H106.5C106.224 111.5 106 111.5 106 111.5ZM124 117H106H124ZM106 117V111V117ZM124 111V117V111Z",
    fill: "#E4E4E4",
    mask: "url(#path-18-inside-7_4168_48649)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-8_4168_48649",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 117.5C30 117.224 30.2239 117 30.5 117H127.5C127.776 117 128 117.224 128 117.5V124.5C128 124.776 127.776 125 127.5 125H30.5C30.2239 125 30 124.776 30 124.5V117.5Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30 117.5C30 117.224 30.2239 117 30.5 117H127.5C127.776 117 128 117.224 128 117.5V124.5C128 124.776 127.776 125 127.5 125H30.5C30.2239 125 30 124.776 30 124.5V117.5Z",
    fill: "#4B81F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30 117.5C30 116.948 30.4477 116.5 31 116.5H127C127.552 116.5 128 116.948 128 117.5C128 117.5 127.776 117.5 127.5 117.5H30.5C30.2239 117.5 30 117.5 30 117.5ZM128 124.5C128 125.052 127.552 125.5 127 125.5H31C30.4477 125.5 30 125.052 30 124.5C30 124.5 30.2239 124.5 30.5 124.5H127.5C127.776 124.5 128 124.5 128 124.5ZM30 125V117V125ZM128 117V125V117Z",
    fill: "#E4E4E4",
    mask: "url(#path-20-inside-8_4168_48649)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 125,
    width: 108,
    height: 8,
    fill: "#4B81F4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 44.5,
    r: 7.5,
    fill: "#EDF3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankImg);
export default __webpack_public_path__ + "static/media/Bank IMG.1c96a1f3429ebef0a86cf208dcab1283.svg";
export { ForwardRef as ReactComponent };